// extracted by mini-css-extract-plugin
export var pillWrapper = "_pr-0";
export var showOverflow = "_pr-1";